/*
 * Ranks the groups of a stat keyed per group and month (aggregateByKeyAndMonth):
 * each group's `field` summed over the `numberOfMonths` months ending at
 * endYear/endMonth, largest first, the first `limit` of them.
 *
 * A row's bar is named by `nameField`; a group without a name (the stat's
 * groupByDefault, e.g. lines without a category) takes `emptyName`.
 */
function rankByGroup(data, { field, groupField, nameField, emptyName = '', limit = 10, endYear, endMonth, numberOfMonths }) {
  const endIndex = endYear * 12 + (endMonth - 1);
  const startIndex = endIndex - numberOfMonths + 1;

  const totals = new Map();
  for (const row of Array.isArray(data) ? data : []) {
    const index = row.year * 12 + (row.month - 1);
    if (index < startIndex || index > endIndex) continue;

    const group = row[groupField];
    const current = totals.get(group);
    totals.set(group, {
      key: current?.key || row[nameField] || emptyName,
      [field]: (current?.[field] || 0) + (row[field] || 0),
    });
  }

  return Array.from(totals.values())
    .map(entry => ({ ...entry, [field]: Math.round(entry[field] * 100) / 100 }))
    .filter(entry => entry[field] !== 0)
    .sort((a, b) => b[field] - a[field])
    .slice(0, limit);
}

export default rankByGroup;
